const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

export const filterBanos = async ({ limit = 10, offset = 1, query = {} }) => {
  try {
    const response = await fetch(`${API_URL}/banos/filter`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ limit, offset, query }),
    });

    if (!response.ok) {
      throw new Error('Error al filtrar baños');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error al filtrar baños:', error);
    throw error;
  }
};

export const createBano = async (banoData) => {
  try {
    const response = await fetch(`${API_URL}/banos/create`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(banoData),
    });

    if (!response.ok) {
      throw new Error('Error al crear el baño');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error al crear el baño:', error);
    throw error;
  }
};

export const updateBano = async (id, banoData) => {
  try {
    const response = await fetch(`${API_URL}/banos/update`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ id, data: banoData }),
    });

    if (!response.ok) {
      throw new Error('Error al actualizar el baño');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error al actualizar el baño:', error);
    throw error;
  }
};

export const deleteBano = async (id) => {
  try {
    const response = await fetch(`${API_URL}/banos/delete/${id}`, {
      method: 'DELETE',
    });

    if (!response.ok) {
      throw new Error('Error al eliminar el baño');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error al eliminar el baño:', error);
    throw error;
  }
};

export const getBanoById = async (id) => {
  try {
    const response = await fetch(`${API_URL}/banos/${id}`, {
      method: 'GET',
    });

    if (!response.ok) {
      throw new Error('Error al obtener el baño');
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error al obtener el baño:', error);
    throw error;
  }
};
